import {analytics, Announcement, cookieHelper} from '@shopify/marketing-assets';
import Waypoint from 'waypoints';

export function StickyBanner(stickyBannerContainer) {
  if (stickyBannerContainer === null) { return; }

  const siteNavContainer = document.querySelector('.site-nav-container');
  const stickyModal = document.querySelector('.sticky-modal');
  const stickySidePrompt = document.querySelector('.sticky-side-prompt');

  if (!stickyModal && !stickySidePrompt && siteNavContainer) {
    document.querySelector('body').insertBefore(stickyBannerContainer, siteNavContainer.nextSibling);
    siteNavContainer.classList.add('unstick-nav');
  }

  const stickyBanner = document.querySelector('.sticky-banner');
  const subNavList = document.querySelector('marketing-nav--secondary');
  const blogHeader = document.querySelector('[data-blog-sticky-banner-waypoint]');
  const element = subNavList || blogHeader;

  function disableStickyBanner() {
    if (!stickyBanner || !siteNavContainer) {
      return;
    }

    stickyBanner.classList.remove('is-active');
    siteNavContainer.classList.add('is-sticky');
  }

  let announcement;

  new Waypoint({
    element,
    offset: () => -element.clientHeight + stickyBanner.clientHeight,
    handler: (dir) => {
      if (dir === 'down') {
        if (stickyBanner.classList.contains('sticky-exclude-desktop') && window.innerWidth > 1080) {
          disableStickyBanner();
        } else if (typeof announcement === 'undefined') {
          announcement = new Announcement(stickyBanner);
          if (!cookieHelper.get(announcement.cookieName)) {
            analytics.track({
              eventCategory: 'sticky-banner-waypoint',
              eventAction: 'scroll-past',
              eventLabel: 'sticky-banner-show',
              nonInteraction: true,
            });
          }
        } else if (!cookieHelper.get(announcement.cookieName)) {
          stickyBanner.classList.add('is-active');
        }
      } else if (typeof announcement !== 'undefined' && !cookieHelper.get(announcement.cookieName)) {
        stickyBanner.classList.remove('is-active');
      }
    },
  });
}
